var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_421_1141)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_421_1141)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "white",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_421_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3256 11.5858C28.5551 11.9597 25.6361 11.9981 22.9184 12.506C22.3411 12.603 21.9601 12.9846 21.5565 13.3794L9.84667 25.0725C8.7174 26.2001 8.71815 28.0481 9.84667 29.1749L16.2495 35.5594C17.3781 36.6862 19.2234 36.6862 20.3519 35.5594L32.1906 23.7374C32.7225 23.253 32.9452 22.6395 33.0556 21.9255L33.8654 14.1155C33.9407 13.3804 33.7048 12.6843 33.2313 12.2116C32.7578 11.7388 32.0611 11.5108 31.3256 11.5858ZM29.2008 14.9989C29.5517 15.0052 29.8865 15.1474 30.1344 15.3954C30.388 15.6489 30.5305 15.9925 30.5305 16.3508C30.5305 16.709 30.388 17.0527 30.1344 17.3061C30.0087 17.4318 29.8594 17.5315 29.695 17.5996C29.5307 17.6676 29.3545 17.7026 29.1766 17.7026C28.9987 17.7026 28.8225 17.6676 28.6581 17.5996C28.4938 17.5315 28.3445 17.4318 28.2187 17.3061C27.9651 17.0527 27.8226 16.709 27.8226 16.3508C27.8226 15.9925 27.9651 15.6489 28.2187 15.3954C28.3473 15.2668 28.5006 15.1654 28.6693 15.0973C28.8381 15.0291 29.0188 14.9957 29.2008 14.9989ZM19.4568 20.6188C20.0398 20.6189 20.6212 20.8402 21.063 21.2813C21.9465 22.1635 21.9471 23.6092 21.063 24.492C20.1789 25.3748 18.7242 25.3809 17.8406 24.4986C16.9571 23.6164 16.9632 22.1641 17.8473 21.2813C18.2894 20.8399 18.8739 20.6187 19.4568 20.6188ZM19.4568 21.8535C19.1941 21.853 18.932 21.9537 18.7274 22.158C18.3182 22.5666 18.3153 23.2156 18.7207 23.6203C19.126 24.025 19.7688 24.0171 20.1779 23.6086C20.5871 23.2 20.59 22.5627 20.1846 22.158C19.9819 21.9556 19.7196 21.854 19.4568 21.8535ZM13.929 25.715C13.9295 25.715 13.9301 25.715 13.9307 25.715L23.8654 26.0195C24.0298 26.0236 24.1859 26.0926 24.2997 26.2114C24.4135 26.3302 24.4757 26.4891 24.4727 26.6536C24.4707 26.7359 24.4524 26.8169 24.4188 26.8921C24.3853 26.9673 24.3372 27.0351 24.2773 27.0915C24.2174 27.148 24.1469 27.192 24.0699 27.2211C23.9929 27.2502 23.9109 27.2637 23.8286 27.2609L13.8938 26.9664C13.8116 26.9644 13.7305 26.9461 13.6553 26.9125C13.5801 26.879 13.5124 26.8309 13.4559 26.771C13.3994 26.7111 13.3554 26.6406 13.3263 26.5636C13.2972 26.4866 13.2837 26.4046 13.2865 26.3223C13.2886 26.2402 13.3068 26.1592 13.3403 26.0842C13.3737 26.0091 13.4217 25.9414 13.4814 25.885C13.5411 25.8285 13.6114 25.7844 13.6882 25.7553C13.765 25.7261 13.8468 25.7124 13.929 25.715ZM18.555 27.8113C19.1396 27.8098 19.7244 28.0278 20.1662 28.4689C21.0498 29.3511 21.0437 30.8034 20.1595 31.6862C19.2754 32.569 17.8274 32.5684 16.9439 31.6862C16.0603 30.804 16.0597 29.3583 16.9439 28.4756C17.3859 28.0342 17.9704 27.8129 18.555 27.8113ZM18.555 29.0511C18.2939 29.0522 18.0335 29.1563 17.8289 29.3606C17.4197 29.7692 17.4169 30.4048 17.8222 30.8095C18.2276 31.2142 18.8703 31.2181 19.2795 30.8095C19.6887 30.4009 19.6848 29.7587 19.2795 29.3539C19.0768 29.1516 18.8161 29.0499 18.555 29.0511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1138 9.00097C29.9741 9.01355 29.8426 9.07302 29.7409 9.16973C29.6392 9.26644 29.5732 9.3947 29.5536 9.53367L28.6719 15.4301C28.6598 15.5109 28.6638 15.5933 28.6835 15.6726C28.7033 15.7519 28.7385 15.8265 28.7871 15.8922C28.8357 15.9579 28.8968 16.0133 28.9669 16.0554C29.0369 16.0974 29.1146 16.1253 29.1954 16.1373C29.2762 16.1494 29.3586 16.1454 29.4379 16.1257C29.5172 16.1059 29.5918 16.0707 29.6574 16.0221C29.7231 15.9735 29.7786 15.9124 29.8206 15.8423C29.8627 15.7723 29.8905 15.6946 29.9026 15.6138L30.7843 9.71736C30.7964 9.63655 30.7924 9.55415 30.7726 9.47487C30.7529 9.39559 30.7177 9.32099 30.669 9.25532C30.6204 9.18964 30.5594 9.13419 30.4893 9.09213C30.4193 9.05006 30.3416 9.02221 30.2608 9.01016C30.2123 9.00129 30.163 8.9982 30.1138 9.00097Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_421_1141",
    x: 0,
    y: 0,
    width: 45,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.7125 0 0 0 0 0.7125 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_421_1141"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_421_1141",
    x: -4,
    y: 0,
    width: 50.8794,
    height: 53.4043,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.516667 0 0 0 0 0.120556 0 0 0 0 0.120556 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_421_1141"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_421_1141",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_421_1141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.6251bb906252f3a3ad50a2cdd1e396c3.svg";
export { ForwardRef as ReactComponent };